// Texto 29 (4b/4c, REGRAS 2.4): qual caixa de anotações a pessoa tocou por último.
// Cada toque na tela passa primeiro pela área com rolagem (tocouEm(null)) e depois pela caixa (tocouEm(id)), na fase de
// captura; no fim do toque fica valendo o mais de dentro. Quando a caixa ativa muda, a anterior "foi deixada":
// os itens vazios dela somem e a barra de baixo volta a pôr os blocos no fim da caixa.
let atual: string | null = null;
let pendente: string | null | undefined;
let agendado = false;
const ouvintes = new Set<(antes: string | null, agora: string | null) => void>();

export function tocouEm(id: string | null) {
  pendente = id;
  if (agendado) return;
  agendado = true;
  setTimeout(() => {
    agendado = false;
    const novo = pendente ?? null;
    pendente = undefined;
    if (novo === atual) return;
    const antes = atual;
    atual = novo;
    ouvintes.forEach(f => f(antes, novo));
  }, 0);
}

/** Chama fn quando a pessoa deixa a caixa id (tocou fora dela). Devolve a função que desliga. */
export function aoSairDaCaixa(id: string, fn: () => void) {
  const f = (antes: string | null, agora: string | null) => { if (antes === id && agora !== id) fn(); };
  ouvintes.add(f);
  return () => { ouvintes.delete(f); };
}
